module.exports = __webpack_public_path__ + "img/pp-logo.343191eb.jpg";